var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-nav" },
    [
      _c("workspace-selector"),
      _c("div", {
        staticClass: "settings-divider",
        attrs: { "aria-hidden": "true" }
      }),
      _c(
        "div",
        { staticClass: "settings-actions" },
        [
          _c("settings-locale", {
            attrs: {
              label: _vm.$t("settings.language"),
              children: _vm.countries.getCountriesTranslate(),
              icon: "translate"
            },
            on: {
              selected: function($event) {
                return _vm.switchLocale($event)
              }
            }
          }),
          _vm.themeChoiceAllowed
            ? _c("settings-link", {
                attrs: {
                  label: _vm.$t("settings.theme"),
                  children: _vm.theme,
                  icon: _vm.themeIcon
                },
                on: {
                  selected: function($event) {
                    return _vm.handleThemeSelection($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }